import { Component, OnInit, Input } from '@angular/core';
import { AnalyticsHelper } from 'src/app/helpers/analytics';
@Component({
  selector: "analytics-table-by-channel",
  templateUrl: "./analytics-table-by-channel.component.html",
  styleUrls: ["./analytics-table.component.scss"]
})
export class AnalyticsTableByChannel {
  @Input() textChannel!: any;
  @Input() lstChannel!: any;
  @Input() textChannelCcBj!: any;

  isChannelLv2(channelName: string) {
    if(channelName == 'Food_N' || channelName == 'Food_L' )
      return true;
    return AnalyticsHelper.ChannelLv2().some((obj) => obj.channel === channelName && obj.level === 2 && channelName != 'Retail' && channelName != 'Food');
  }
  isChannelLv2RetailFood(channelName: string) {
    if (AnalyticsHelper.retailSaleDivisionChannel().some((obj) => obj.channel === channelName)
      || AnalyticsHelper.alcoholChannel().some((obj) => obj.channel === channelName)
      || AnalyticsHelper.FoodBranches().some((obj) => obj.name === channelName))
      return true;
    else
      return false;

  }

  removeLeadingPlus(value: any): string {
     return String(value ?? '')
    .trim()
    .replace(/^\+/, '')
    .replace(/,/g, '');
  }

  isNegativeAfterNormalize(value: any): boolean {
    const normalized = this.removeLeadingPlus(value);
    const num = Number(normalized);
    if(num > 3310 && num< 3321)
    {
      debugger
    }
    return !isNaN(num) && num >= 0;
  }
}